import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import PageHeader from '../components/PageHeader';

export default function ExamplesView() {
  React.useEffect(() => {}, []);

  const pageHeader = {
    title: 'About Me',
    description:
      "Multiple lines of text that form the lede, informing new readers quickly and efficiently about what's most interesting in this post's contents.",
    image: 'about_me',
    imageText: 'main image description',
  };
  return (
    <React.Fragment>
      <Container
        disableGutters
        maxWidth='2xl'
        component='main'
        sx={{
          display: 'flex',
          width: '100%',
          marginBottom: 12,
          alignItems: 'center',
          justifyContent: 'space-around',
          flexDirection: 'column',
        }}
      >
        <PageHeader post={pageHeader} />
        <Container>
          <Typography
            sx={{ textAlign: 'center', mx: 7, mb: 5, mt: { xs: 10, lg: 20 } }}
          >
            Hello! I'm Sheline Lampart known to my family and friends as Shey.
            I'm based out of Sugar Land Texas, just outside Houston. I'm
            originally a nurse by trade for over 25 years. Arts and crafts have
            always been a part of my life, it's therapy for the mind, body and
            soul. I get to share my creative world with my daughter and mother,
            my biggest fans. I've grown my hobby into an entrepreunership, from
            a small craft room to an entire garage studio. As a self proclaimed
            crafty artist, I specialize in acrylic abstract art using different
            application techniques and mediums. I use a variety of wreaths to
            create a custom masterpiece for any occasion, season or holiday. My
            flower arrangements add that touch to pull together a room.
          </Typography>
          <Typography sx={{ textAlign: 'center', mx: 7, mb: 5 }}>
            Art is about expression, there are no rules or right way to create
            it. My inspiration comes from all around me. Colors, scenes,
            experiences and people. Perhaps my most influencial inspiration is
            the beach. Much like my art, the beach and ocean offer color,
            movement and texture, appealing to the senses. My style ranges from
            simple strokes to multi demensional layers of colors and textured
            elements. My crafts allow me to use many different elements, colors
            and textures. I feel my creations help make a house a home. I love
            taking someone's vision and creating a custom piece from their
            inspiration.
          </Typography>
          <Typography sx={{ textAlign: 'center', mx: 7, mb: 5 }}>
            Thank you for visiting my website. I hope you find inspiration in my
            arts and crafts and allow me to bring your vision to life!
          </Typography>
        </Container>
      </Container>
    </React.Fragment>
  );
}
